import cn from 'classnames/bind';
import React, { FunctionComponent, HTMLAttributes } from 'react';
import type { RouterLocation } from '@funtech-int/rival';
import { RouterLink } from '@funtech-int/rival-react';

import styles from './BasicCard.module.css';

const cx = cn.bind(styles);

interface BasicCardProps {
    img: string;
    title?: string;
    location?: RouterLocation<unknown, unknown>;
    onClick?: HTMLAttributes<HTMLElement>['onClick'];
    imgViewVariant?: 'cover' | 'contain';
}

export const BasicCard: FunctionComponent<BasicCardProps> = ({
    img,
    onClick,
    title,
    location,
    imgViewVariant = 'cover',
}) => {
    const image = img ? (
        <div
            role="img"
            aria-label={title}
            title={title}
            className={cx('image', `image_${imgViewVariant}`)}
            style={{ backgroundImage: `url(${img})` }}
        />
    ) : null;

    if (location) {
        return (
            <RouterLink to={location} onClick={onClick} className={cx('root')}>
                {image}
            </RouterLink>
        );
    }

    return (
        <div
            tabIndex={-1}
            className={cx('root', { root_clickable: Boolean(onClick) })}
            role="presentation"
            onClick={onClick}
        >
            {image}
        </div>
    );
};
